/*
 *   File : Login.js
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

//custom components
import { Link } from "react-router-dom";
import { PrimaryButton } from "../../Components/Cta/index";
import Icon from "../../Components/icons";
import { Input, Password, OTPInput } from "../../Components/FormElements/index";
import { APIService } from "../../Service";

//custom style
import "../../Style/Pages/login.scss";

export default function Login() {
  const otpInputRef = useRef(null);
  // const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);

  const [otpModal, setOtpModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [focusedInput, setFocusedInput] = useState(2);
  const [confirmOTP, setConfirmOTP] = useState([]);
  const [otpError, setOtpError] = useState("");
  // const [loader, setLoader] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", //scroll top
    });
  }, []);

  //otp input
  useEffect(() => {
    if (otpInputRef) return;
    otpInputRef.current[0]?.focus();
  }, []);

  useEffect(() => {
    setEmailError("");
  }, [email]);

  useEffect(() => {
    setPasswordError("");
  }, [password]);

  useEffect(() => {
    setOtpError("");
  }, [otpValue]);

  // handle OTP
  // const _handleOTP = (e) => {
  //   if (!loading) {
  //     const input_value = e.target.value;
  //     if (input_value.length <= 4) {
  //       setOtpValue(input_value);
  //       setConfirmOTP([...input_value]); // simpler
  //     }
  //   }
  // };

  // Handles email/password validation and shows OTP modal
  const _validateLogin = (e) => {
    let isValid = true;
    let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
    if (email.trim().length === 0) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!validate_email.test(email)) {
      setEmailError("Please provide a valid email");
      isValid = false;
    }
    if (password.trim().length === 0) {
      setPasswordError("Password is required");
      isValid = false;
    }
    if (isValid === true) {
      _handleLogin();
    }
  };

  const _handleLogin = () => {
    setLoading(true);
    let is_post = true;
    let url = "auth/login";
    let data = {
      email: email,
      password: password,
    };

    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        setOtpModal(true);
      } else {
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
      }
      setLoading(false);
    });
  };

  // handle submit OTP
  const _handleSubmitOTP = () => {
    // if (otpValue.length < 4) {
    //   if (otpInputRef.current) {
    //     otpInputRef.current.focus();
    //   }
    //   setOtpError("Enter received OTP");
    // }

    // if (otpValue.length === 4) {
    //   if (_verifyOtp()) {
    //     Cookies.set("access_token", "token");
    //     window.location.href = "/";
    //   } else {
    //     setOtpError(true);
    //   }
    // }
    if (otpValue.length < 4) {
      setOtpError("Enter received OTP");
      return;
    }
    if (otpValue.length === 4) {
      _verifyOtp();
    }
  };

  //verify otp
  const _verifyOtp = () => {
    setLoading(true);

    // if (otpValue === "1234") {
    //   setOtpError(""); // clear error
    //   setLoading(false);
    //   return true;
    // }
    // setOtpError("Invalid OTP");
    // setOtpValue("");
    // setConfirmOTP([]);
    // setFocusedInput(2);

    // // refocus the input
    // if (otpInputRef.current) {
    //   otpInputRef.current.focus();
    // }

    // setLoading(false);
    // return false;

    let is_post = true;
    let url = "auth/verify-otp";
    let data = {
      email: email,
      otp: otpValue,
      type: "LOGIN",
    };
    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        setOtpValue("");
        setConfirmOTP([]);
        Cookies.set("access_token", response.access_token, {
          // path: "/", // always needed
          sameSite: "None", // important for cross-site requests
          secure: true,
          domain: process.env.REACT_APP_DOMAIN,
        });
        toast.success(response.message, {
          type: "success",
          className: "e-toast",
        });
        // window.location.href = "/corridor-config";
        window.location.replace("/");
      } else {
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
        setOtpValue("");
        setConfirmOTP([]);
      }
      setLoading(false);
    });
  };

  // handle OTP
  const _handleOTP = (e) => {
    if (loading !== true) {
      const input_value = e.target.value;
      if (input_value.length <= 4) {
        setOtpValue(input_value);
        const characters = [];

        for (let i = 0; i < input_value.length; i++) {
          const character = input_value.charAt(i);
          characters.push(character);
        }
        setConfirmOTP(characters);
      }
    }
  };

  // handle resend OTP
  const _handleResendOTP = () => {
    setOtpValue("");
    setConfirmOTP([]);
    _sentOTP();
  };

  // API - Send OTP
  const _sentOTP = () => {
    let is_post = true;
    let url = "auth/resend";
    let data = {
      email: email,
      type: "LOGIN",
    };

    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        setOtpValue("");
        setConfirmOTP([]);
        // Cookies.set('access_token', response.access_token, { domain: process.env.REACT_APP_DOMAIN, path: '/' });
        toast.success(response.message, {
          type: "success",
          className: "e-toast",
        });
        // window.location.href = "/corridor-config";
      } else {
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
      }
    });
  };

  return (
    <div className="col-12 e-pt-104px ">
      <div className="row">
        {otpModal && (
          <Link
            to="#"
            className="text-decoration-none e-text-blue-violet d-flex align-items-center pb-3"
            onClick={() => {
              setOtpModal(false);
              setOtpValue([]);
            }}
          >
            <Icon icon="arrow-left" size={15} color="e-text-blue-violet" />
            <span className="ps-2">Go back</span>
          </Link>
        )}

        <h3 className="e-text-black e-primary-font-poppins e-font-weight-600 e-font-22">
          {otpModal ? "OTP Verification" : "Login"}
        </h3>
        <p className="e-text-black e-font-weight-400 e-font-14">
          {otpModal ? (
            <>
              Enter the 4-digit code sent to{" "}
              <span className="e-text-blue-violet">{email}</span>
            </>
          ) : (
            "Lorem ipsum dolor sit amet, consectetur."
          )}
        </p>
      </div>

      {otpModal ? (
        <>
          <OTPInput
            label="OTP"
            ref={otpInputRef}
            id="otp"
            value={otpValue}
            spellcheck="false"
            error={otpError}
            require={true}
            focused_input={focusedInput}
            confirm_pin={confirmOTP}
            onFocus={() => setFocusedInput(2)}
            onBlur={() => setFocusedInput(0)}
            onKeyPress={_handleSubmitOTP}
            onChange={_handleOTP}
          />

          <div className="row pt-3">
            {/* <Link
              to="/"
              className="text-decoration-none e-font-weight-400 e-font-14 text-muted d-flex align-items-center e-cursor-pointer pb-3"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              Didn’t get code yet?
              <span className="ps-2 e-text-blue-violet e-font-weight-400 e-font-14">
                Resend OTP
              </span>
            </Link> */}
            <p className="mb-0 text-decoration-none e-font-weight-400 e-font-14 text-muted d-flex align-items-center pb-3">
              Didn’t get code yet?
              <span
                className="e-cursor-pointer ps-2 e-text-blue-violet e-font-weight-500 e-font-14"
                onClick={_handleResendOTP}
              >
                Resend OTP
              </span>
            </p>
          </div>

          <div className="row mt-2">
            <PrimaryButton
              ClassName="rounded-pill e-bg-blue-violet text-white e-primary-font-poppins"
              name="Verify"
              loading={loading}
              onPress={_handleSubmitOTP}
            />
          </div>
        </>
      ) : (
        <>
          <div className="row pt-3">
            <Input
              id="1"
              type="email"
              label="Email"
              placeholder="Enter your email address"
              require={true}
              value={email}
              error={emailError}
              className="e-primary-font-poppins w-100"
              onKeyPress={_validateLogin}
              handleChange={(e) => setEmail(e)}
              autoFocus={true}
            />
          </div>

          <div className="row pt-3">
            <Password
              id="2"
              label="Password"
              placeholder="Enter password"
              require={true}
              value={password}
              error={passwordError}
              className="e-primary-font-poppins w-100"
              onKeyPress={_validateLogin}
              handleChange={(e) => setPassword(e)}
            />
          </div>

          <div className="row text-end pt-2 pb-2">
            <Link
              to={"/forgot-password"}
              className="e-font-weight-400 e-font-14 text-decoration-none e-text-blue-violet"
            >
              <span className="e-font-weight-400 e-font-14 pe-2 e-text-black text-capitalize e-primary-font-poppins">
                Forgot password?
              </span>
              Reset
            </Link>
          </div>

          <div className="row">
            <div className="col-12">
              <PrimaryButton
                loading={loading}
                ClassName="rounded-pill e-bg-blue-violet text-white e-primary-font-poppins w-100"
                name="Get OTP"
                onPress={_validateLogin}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
